export default __webpack_public_path__ + "static/media/top_performer (3).96acdd39.png";